import React, { useEffect } from 'react';
import 'react-table-v6/react-table.css';
import Sidebar from '../../commonAdmin/Sidebar';
import Header from '../../commonAdmin/Header';
import { Col, Container, Row } from 'react-bootstrap';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import delivaApiService from '../../../../common/services/apiService';
import Loader from '../../../common/Loader';
import { getCurrencySymbol } from '../../../../common/helpers/Utils';

const ReferralDetails = (props) => {
  const { countries } = props;
  const [showLoader, setShowLoader] = React.useState(false);
  const [referralDetail, setReferralDetail] = React.useState(null);
  // hooks
  const history = useHistory();

  //
  const { id } = useParams();
  // console.log('path id', id);

  // const { state } = useLocation();
  // const { id } = state;
  // console.log('Line 25 this is details id', id)

  // Referal Data
  const ReferralDetailsData = (id) => {
    setShowLoader(true);
    delivaApiService('getReferral', { referralId: id })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setReferralDetail(data);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error('Failed to update status:', error);
      });
  };

  useEffect(() => {
    if (id) {
      setReferralDetail(null);
      setShowLoader(true);
      ReferralDetailsData(id);
    }
  }, [id]);

  const getCurrencyParts = (currencyString) => {
    const match = currencyString.match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      return {
        name: match[1].trim(), // "Nigerian naira"
        symbol: match[2].trim(), // "₦"
      };
    }
    return {
      name: currencyString,
      symbol: '',
    };
  };

  const currencyParts = getCurrencyParts(referralDetail?.currency || '');

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <section className="page-header mb-4">
                  <div className="w-100">
                    <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                      Referral Details
                    </h3>
                    <h5 className="font-weight-normal mb-0 line-ht color-head">
                      <span
                        className="pointer"
                        onClick={() =>
                          history.push({
                            pathname: `/promotionReferralList`,
                            state: {
                              tab: 'referral',
                            },
                          })
                        }
                      >
                        Promotion & Referral
                      </span>
                      <span className="icon-next mx-2 fs12"></span>
                      <span className="pointer">Referral Details </span>
                    </h5>
                  </div>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      {showLoader || !referralDetail ? (
                        <div style={{ minHeight: 100 }}>
                          <Loader showLoader={true} />
                        </div>
                      ) : (
                        <>
                          <h5 className="px-4">
                            {referralDetail?.userType === 'delivery_agent'
                              ? 'Delivery Partner'
                              : 'Sender'}
                          </h5>
                          <hr />
                        </>
                      )}
                    </Col>
                  </Row>
                  {!showLoader && referralDetail && (
                    <>
                      <Row className="px-4">
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Discount Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {referralDetail?.discountType
                              ? referralDetail?.discountType
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Referral Condition
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {referralDetail?.referralCondition
                              ? referralDetail?.referralCondition.join(' and ')
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Referral Count
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {referralDetail?.referralCount
                              ? referralDetail?.referralCount
                              : '--'}
                          </p>
                        </Col>

                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Delivery Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {referralDetail?.deliveryRequestType
                              ? referralDetail?.deliveryRequestType
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Name of Offer
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {referralDetail?.offerName
                              ? referralDetail?.offerName
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Promotion Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            Free Delivery
                          </p>
                        </Col>
                        {referralDetail?.userType !== 'delivery_agent' && (
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              % Of Discount
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {referralDetail?.percentageDiscount
                                ? referralDetail?.percentageDiscount
                                : '--'}
                              %
                            </p>
                          </Col>
                        )}
                        {referralDetail?.userType === 'delivery_agent' && (
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Reward Amount
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {referralDetail?.discountAmount
                                ? `${getCurrencySymbol(referralDetail?.currency, countries)}${referralDetail?.discountAmount}`
                                : '--'}
                            </p>
                          </Col>
                        )}
                        {referralDetail?.userType !== 'delivery_agent' && (
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Max Amount of Discount(upto)
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {referralDetail?.maxDiscountAmount
                                ? `${currencyParts?.symbol} ${referralDetail?.maxDiscountAmount}`
                                : '--'}
                            </p>
                          </Col>
                        )}
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Country
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {referralDetail?.region
                              ? referralDetail?.region
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Currency
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {referralDetail?.currency
                              ? referralDetail?.currency
                              : '--'}{' '}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Discount Application
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {referralDetail?.discountApplicationType
                              ? referralDetail?.discountApplicationType
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Code
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {referralDetail?.code ? referralDetail?.code : '--'}
                          </p>
                        </Col>
                      </Row>
                    </>
                  )}
                </section>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default connect((state) => ({ countries: state.country.countries }))(ReferralDetails);
